
<div class="pt-5 pb-4 position-relative"></div>
<div class="container mt-5">

  <div class="row justify-content-center">
    <div class="col-md-6">
      <div class="card">
        <div class="card-body p-4" style="background-color: var(--warna-1)!important;">
           


            <div *ngIf="step === 'phone' && showLoginForm" class="phone-step">
              <h3 class="text-center mb-4" style="color: var(--warna-2)">
                {{ mode === 'add' ? 'Add Your Phone Number' : 'Update Your Phone Number' }}
              </h3>
              <p>
                {{ mode === 'add' 
                  ? 'Once verified, your phone number can be used for login in the future.' 
                  : 'Update your phone number to receive notifications and secure your account.'
                }}
              </p>

                <!-- Form Login Phone -->
                <form [formGroup]="phoneForm" (ngSubmit)="onContinueWithPhone()">
        
              
                  <!-- Input Nomor Telepon -->
                  <div class="mb-3">
                    <input 
                      #phoneInput
                      type="tel"
                      class="form-control"
                      id="phone"
                      formControlName="phone"
                      [ngClass]="{'is-invalid': submitted && phoneForm.get('phone')?.invalid}"
                                          
                    >
                    <div class="text-danger" *ngIf="submitted">
                      <div *ngIf="hasError(phoneForm, 'phone', 'required')">Phone number is required</div>
                      <div *ngIf="hasError(phoneForm, 'phone', 'pattern')">Please enter a valid phone number</div>
                    </div>
                    <small class="form-text text-muted mt-2">
                     A verification code will be sent to your <strong>WhatsApp</strong>.
                    </small>
                  </div>
              
                  <button type="submit" class="btn btn-primary w-100" [disabled]="isLoading">
                    <span *ngIf="!isLoading">{{ mode === 'add' ? 'Continue' : 'Update' }}</span>
                    <span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  </button>
                </form>
          

              </div>


  <div *ngIf="step === 'otp' && showLoginForm" class="otp-step">

    <div class="mb-3">
      <span class="link-buatan" (click)="switchToWA()">  <i class="fa fa-chevron-left"></i> </span>
    </div>


        <!-- Form Verifikasi OTP -->
      <form [formGroup]="otpForm" (ngSubmit)="onVerifyOtp()">
          <div class="mt-3 mb-5 text-center">
            <h3 style="color:var(--warna-2)">Enter Code</h3>
            <p>A verification code will be sent to your <strong>WhatsApp</strong></p>
          </div>
          
          <div class="mb-3">
              <!-- <span class="link-buatan" (click)="switchToEmailLogin()">  <i class="fa fa-chevron-left"></i> </span> -->
          </div>


          <!-- Input OTP -->
          <div class="mb-3">
            <input 
              type="text"
              class="form-control"
              id="otp"
              formControlName="otp"
              [ngClass]="{'is-invalid': submitted && otpForm.get('otp')?.invalid}"
              placeholder="Enter OTP"
            >
            <div class="text-danger" *ngIf="submitted">
              <div *ngIf="hasError(otpForm, 'otp', 'required')">OTP is required</div>
              <div *ngIf="hasError(otpForm, 'otp', 'pattern')">Please enter a valid 6-digit OTP</div>
            </div>
            <small class="form-text text-muted mt-2">
              Enter the 6-digit code sent to your <strong>WhatsApp</strong>.
            </small>
          </div>
      
          <button type="submit" class="btn btn-primary w-100" [disabled]="isLoading">
            <span *ngIf="!isLoading">{{ mode === 'add' ? 'Continue' : 'Update' }}</span>
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          </button>
      
          <!-- Countdown Timer -->
          <div *ngIf="remainingTime > 0" class="text-center mt-3">
            <small class="text-muted">Resend to WhatsApp : <strong>{{ formatTime(remainingTime) }}</strong></small>
          </div>
      
          <!-- Link untuk Request OTP Ulang -->
          <div *ngIf="remainingTime === 0" class="text-center mt-3">
            <span class="link-buatan" (click)="onRequestOtpAgain()">Resend to WhatsApp</span>
            <!-- <button class="btn btn-link" (click)="onRequestOtpAgain()">Request OTP Again</button> -->
          </div>
      </form>
  </div>

    
  <div class="row mb-3 mt-3 text-center">
    <div class="col-md-12">
        <span class="text-secondary" style="text-decoration: underline; cursor: pointer;" (click)="kembali()">cancel & back</span>
    </div>
</div>
        </div>
      </div>
    </div>
</div>

</div>


<div class="modal fade" id="pesanModal" tabindex="-1" aria-labelledby="pesanModalLabel" aria-hidden="true" #pesanModal>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="pesanModalLabel"><i class='fas fa-exclamation-circle'></i> Please Note</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
       <p><strong>{{no_wa}}</strong> is currently connected to another account. if You continue, that account <strong>whatsApp number</strong> will be transferred to this account. </p> 
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="lanjut_simpan()">Continue</button>
      </div>
    </div>
  </div>
</div>